import { useEffect } from 'react'
import { useUtmTracking } from '@/hooks/useUtmTracking'

const UtmTracker = () => {
  const { updateLinksWithUtms } = useUtmTracking()

  useEffect(() => {
    // Update links with UTM parameters after component mounts
    const timer = setTimeout(() => {
      updateLinksWithUtms()
    }, 100) // Small delay to ensure DOM is ready

    return () => clearTimeout(timer)
  }, [updateLinksWithUtms])

  // Also update links when the component re-renders (route changes)
  useEffect(() => {
    updateLinksWithUtms()
  })

  return null // This component doesn't render anything
}

export default UtmTracker
